/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Train_LeadInputs */

const en_features_train_lead = /** @type {(inputs: Features_Train_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every set in one tap.`)
};

const pl_features_train_lead = /** @type {(inputs: Features_Train_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda seria jednym dotknięciem.`)
};

/**
* | output |
* | --- |
* | "Every set in one tap." |
*
* @param {Features_Train_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_train_lead = /** @type {((inputs?: Features_Train_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Train_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_train_lead(inputs)
	return en_features_train_lead(inputs)
});